//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export const THRESHOLD_PERCENTAGE = 10;

export const ERROR_COLUMNS = {
  LINE: 1,
  ID: 2,
  TITLE: 3,
  LINK: 4,
  IMAGE_LINK: 5,
};

export const IMAGE_WIDTH = '175px';
export const IMAGE_HEIGHT = '250px';
